const table = {
    table_container: 'overflow-x-auto nice-scrollbar whitespace-nowrap',
    table: 'text-left w-full border-collapse',
    th_text: 'text-[10px] text-zinc-700 text-bricolage font-medium',
    td_text: 'text-[#42484e]',
    tr: 'transition-all hover:bg-neutral-50 active:bg-neutral-100 group table-tr border-t first:border-t-0 border-black/10 hover:border-white',
    tr_first: 'border-t-0',
};

table.th = `${table.th_text} py-1 px-2 lg:py-1.5 lg:px-4 text-left whitespace-nowrap border-b border-black/10 `;
table.th_first = ``;
table.th_last = `!text-right`;
table.td = `${table.td_text} py-2 px-2 lg:py-2.5 lg:px-4 text-sm cursor-pointer leading-normal`;
table.td_sm = `${table.td_text} py-1 px-2 lg:py-2 lg:px-4 text-sm cursor-pointer`;
table.td_first = `rounded-l-lg`;
table.td_last = `text-right rounded-r-lg`;

export default table;
